import { getLink } from '../helpers';

/**
 * Returns the list of choices that'll actually get displayed
 * on the screen, weeding out those with empty labels and picking
 * the right one when they have conditions
 * @param {Object} variant
 * @returns {Array}
 */
export function getChoicesToDisplay(variant, history) {
  return variant.choices
    .map((choice) => {
      // Set the link that'll actually be used when clicking
      // in case the choice is conditional

      // not fetching if AL

      const link = choice.conditional_logic_block_present
        ? {}
        : getLink(choice, history);
      return {
        ...choice,
        // There might be no link if the choice points to nowhere
        // TODO: Maybe that should be weeded out by the server already
        label: choice.label || link?.label,
        link,
      };
    })
    .filter(
      // Choices can still have an empty label:
      // - for an external URL that's not filled in yet
      // - for a link pointing nowhere with no label
      (choice) => !choice.hidden && choice.label
    );
}

export function mediaUrlOfType(mediaType, variant) {
  if (!variant.media_alternative_sources) return;
  return variant.media_alternative_sources.find(
    (source) => (source.mime = mediaType)
  )?.url;
}
